module.exports = __webpack_public_path__ + "static/media/batch-prediction-rounded-48dp.1b1cf5f9.svg";